export const apiHost = 'https://backendinv.hcl1.com/api';
